module.exports = __webpack_public_path__ + "img/stbg01.f0f0b0ac.png";